declare var Elements;

let requestAnimationFrame = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function (fn) {
        return window.setTimeout(fn, 20);
    };


function forEachElement(elements, callback) {
    let elementsType = Object.prototype.toString.call(elements);
    let isCollectionTyped = ('[object Array]' === elementsType
        || ('[object NodeList]' === elementsType)
        || ('[object HTMLCollection]' === elementsType)
        || ('[object Object]' === elementsType)
        || ('undefined' !== typeof jQuery && elements instanceof jQuery) //jquery
        || ('undefined' !== typeof Elements && elements instanceof Elements) //mootools
    );
    let i = 0, j = elements.length;
    if (isCollectionTyped) {
        for (; i < j; i++) {
            callback(elements[i]);
        }
    } else {
        callback(elements);
    }
}

function EventQueue() {
    let q = [];
    this.add = function (ev) {
        q.push(ev);
    };

    let i, j;
    this.call = function () {
        for (i = 0, j = q.length; i < j; i++) {
            q[i].call();
        }
    };

    this.remove = function (ev) {
        let newQueue = [];
        for (i = 0, j = q.length; i < j; i++) {
            if (q[i] !== ev) newQueue.push(q[i]);
        }
        q = newQueue;
    }

    this.length = function () {
        return q.length;
    }
}

function attachResizeEvent(element, resized) {
    if (!element) return;
    if (element.resizedAttached) {
        element.resizedAttached.add(resized);
        return;
    }

    element.resizedAttached = new EventQueue();
    element.resizedAttached.add(resized);

    element.resizeSensor = document.createElement('div');
    element.resizeSensor.className = 'resize-sensor';
    let style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
    let styleChild = 'position: absolute; left: 0; top: 0; transition: 0s;';

    element.resizeSensor.style.cssText = style;
    element.resizeSensor.innerHTML =
        '<div class="resize-sensor-expand" style="' + style + '">' +
        '<div style="' + styleChild + '"></div>' +
        '</div>' +
        '<div class="resize-sensor-shrink" style="' + style + '">' +
        '<div style="' + styleChild + ' width: 200%; height: 200%"></div>' +
        '</div>';
    element.appendChild(element.resizeSensor);

    if (element.resizeSensor.offsetParent !== element) {
        element.style.position = 'relative';
    }

    let expand = element.resizeSensor.childNodes[0];
    let expandChild = expand.childNodes[0];
    let shrink = element.resizeSensor.childNodes[1];
    let dirty, rafId, newWidth, newHeight;
    let lastWidth = element.offsetWidth;
    let lastHeight = element.offsetHeight;

    let reset = function () {
        let saveDisplay = element.style.display;
        element.style.display = "block";

        expandChild.style.width = '100000px';
        expandChild.style.height = '100000px';

        expand.scrollLeft = 100000;
        expand.scrollTop = 100000;

        shrink.scrollLeft = 100000;
        shrink.scrollTop = 100000;
        element.style.display = saveDisplay;
    };

    reset();

    let onResized = function () {
        rafId = 0;

        if (!dirty) return;

        lastWidth = newWidth;
        lastHeight = newHeight;

        if (element.resizedAttached) {
            element.resizedAttached.call();
        }
    };

    let onScroll = function () {
        newWidth = element.offsetWidth;
        newHeight = element.offsetHeight;
        dirty = newWidth != lastWidth || newHeight != lastHeight;

        if (dirty && !rafId) {
            rafId = requestAnimationFrame(onResized);
        }

        reset();
    };

    let addEvent = function (el, name, cb) {
        if (el.attachEvent) {
            el.attachEvent('on' + name, cb);
        } else {
            el.addEventListener(name, cb);
        }
    };

    addEvent(expand, 'scroll', onScroll);
    addEvent(shrink, 'scroll', onScroll);
}

function detach(element, ev) {
    forEachElement(element, function (elem) {
        if (!elem) return
        if (elem.resizedAttached && typeof ev == "function") {
            elem.resizedAttached.remove(ev);
            if (elem.resizedAttached.length()) return;
        }
        if (elem.resizeSensor) {
            if (elem.contains(elem.resizeSensor)) {
                elem.removeChild(elem.resizeSensor);
            }
            delete elem.resizeSensor;
            delete elem.resizedAttached;
        }
    });
};

function isVisible(ele) {
    let style = window.getComputedStyle(ele);
    if (style.display === "none") return false;
    return (ele.parentElement != null) ? isVisible(ele.parentElement) : true;
}

function onceVisible(ele, cb: () => void) {
    if (isVisible(ele)) {
        cb();
        return;
    }
    let h = setInterval(() => {
        if (isVisible(ele)) {
            clearInterval(h);
            cb();
        }
    }, 100);
}

class ResizeSensor {

    constructor(public element, public callback) {
        
        forEachElement(element, function (elem) {
            onceVisible(elem, () => attachResizeEvent(elem, callback));
        });
    }

    detach() {
        detach(this.element, this.callback);
    }

}

export = ResizeSensor;
